<template>
  <div>
    
  </div>
</template>

<script>

export default {
  data() {
    return {
     
    }
  },
  props: {
    title: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    
  },
  mounted () {
  }
}

</script>

<style scoped lang="less">
</style>
